const RELOAD_STORAGE_KEY = "chunk-load-error-reloaded-at";
const RELOAD_COOLDOWN_MS = 30 * 1000;

export function isChunkLoadError(error) {
  const message = error?.message || "";
  const name = error?.name || "";

  // После deploy старая вкладка может попытаться открыть lazy route,
  // который ссылается на chunk из предыдущего release. Разные браузеры и
  // bundler/runtime формулируют эту ошибку по-разному, поэтому проверяем не
  // один точный текст, а несколько известных вариантов.
  return (
    name === "ChunkLoadError" ||
    message.includes("Loading chunk") ||
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("Importing a module script failed")
  );
}

function lastReloadAt() {
  return Number(sessionStorage.getItem(RELOAD_STORAGE_KEY) || 0);
}

export function reloadPageOnceAfterChunkLoadError(error) {
  if (!isChunkLoadError(error)) return false;

  const now = Date.now();
  if (now - lastReloadAt() < RELOAD_COOLDOWN_MS) return false;

  // Здесь не пытаемся "долечить" старую вкладку вручную. Если chunk исчез,
  // единственный надежный способ синхронизировать приложение с новым release -
  // заново загрузить `index.html`, где уже указаны актуальные имена JS/CSS.
  //
  // Reload делаем только один раз за короткий интервал. Если после reload
  // ошибка повторяется, значит проблема уже не в старой вкладке после deploy
  // или сервер все еще отдает некорректные assets. Бесконечная перезагрузка
  // была бы хуже белого экрана: пользователь вообще потеряет контроль над UI.
  sessionStorage.setItem(RELOAD_STORAGE_KEY, String(now));
  window.location.reload();

  return true;
}

export function setupChunkLoadErrorReloadHandlers() {
  window.addEventListener("unhandledrejection", (event) => {
    reloadPageOnceAfterChunkLoadError(event.reason);
  });

  window.addEventListener("error", (event) => {
    reloadPageOnceAfterChunkLoadError(event.error || event);
  });
}
